module.exports = __webpack_public_path__ + "static/img/csb.6bfba2e0.png";